import { useQuery } from '@tanstack/react-query'

import { fetchfilterFields } from '../functions'

const useFetchFilterFields = (leadsType: string) => {
  return useQuery(['leadFilterFields', leadsType], () =>
    fetchfilterFields(leadsType)
  )
}

export { useFetchFilterFields }
